import React from "react";
import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import { FourColGrid } from "./four-col-grid";
import FourColumnFourStories from "./four-col-four-stories";
import { ThreeColTwelveStories } from "./three-col-twelve-stories";
import TwoColumnTwoStories from "./two-col-two-stories";
import PortraitSixStories from "./portrait-six-stories";
import SixColumnSixStories from "./six-col-six-stories";
import { ThreeColThreeStories } from "./three-col-three-stories";
import { ThreeColNineteenStories } from "./three-col-nineteen-stories";
import { ThreeColumnFiveStoriesVarOne } from "./three-column-five-stories-var-one";
import { TwoColFiveStories } from "./two-col-five-stories";
import { ThreeColumnSixStories } from "./three-col-six-stories";
import FourColumnFourStoriesVarOne from "./four-col-four-var-one";
import { FourColFiveStoriesWideHero } from "./four-col-five-stories-wide-hero";
import { ThreeColSevenStories } from "./three-col-seven-stories";
import { FourColumnTenStories } from "./four-column-ten-stories";
import { ThreeColSevenStoriesVarOne } from "./three-col-seven-stories-var-one";
import ThreeColumnNineStoriesVarOne from "./three-col-nine-var-one";
import OneColOneStory from "./one-col-one-story";
import { ThreeColEighteenStories } from "./three-col-eighteen-stories";
import { ThreeColumnNineStoriesVarTwo } from "./three-col-nine-var-two";
import { ThreeColNineStoriesVarOneWithBG } from "./three-col-nine-stories-var-one-with-bg";
import { TwoColumnOneStoryVarOne } from "./two-col-one-story-var-one";
import ThreeColumnFiveStories from "./three-col-five-stories";
import BreakingNewsProminent from "./breaking-news-prominent";
import { YoutubeComponent } from "./youtube-component";
import FourColumnFourStoriesVarTwo from "./four-col-four-stories-var-two";
import { ThreeColTwelveOrEighteenStories } from "./three-col-twelve-or-eighteen-stories";
import { Games } from "./games";
import { TopComponentSectionPage } from "./top-component-section-page";
import { ThreeColNineteenStoriesVarTwo } from "./three-col-nineteen-stories-var-two";

import TopComponentHomePage from "./top-component-home-page";
import ThreeColumnNineStoriesVarThree from "./three-col-nine-var-three";
import SixColumnSevenStories from "./six-col-seven-stories";

function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    if (props.index === 0) {
      return (
        <EagerLoadImages predicate={(token) => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
      );
    } else {
      return React.createElement(f, props);
    }
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  FourColGrid: wrapEager(wrapCollectionLayout(FourColGrid)),
  FourColFiveStoriesWideHero: wrapEager(wrapCollectionLayout(FourColFiveStoriesWideHero)),
  FourColumnFourStories: wrapEager(wrapCollectionLayout(FourColumnFourStories)),
  ThreeColTwelveStories: wrapEager(wrapCollectionLayout(ThreeColTwelveStories)),
  TwoColumnTwoStories: wrapEager(wrapCollectionLayout(TwoColumnTwoStories)),
  PortraitSixStories: wrapEager(wrapCollectionLayout(PortraitSixStories)),
  ThreeColumnSixStories: wrapEager(wrapCollectionLayout(ThreeColumnSixStories)),
  SixColumnSixStories: wrapEager(wrapCollectionLayout(SixColumnSixStories)),
  ThreeColThreeStories: wrapEager(wrapCollectionLayout(ThreeColThreeStories)),
  ThreeColNineteenStories: wrapEager(wrapCollectionLayout(ThreeColNineteenStories)),
  ThreeColumnFiveStoriesVarOne: wrapEager(wrapCollectionLayout(ThreeColumnFiveStoriesVarOne)),
  TwoColFiveStories: wrapEager(wrapCollectionLayout(TwoColFiveStories)),
  FourColumnFourStoriesVarOne: wrapEager(wrapCollectionLayout(FourColumnFourStoriesVarOne)),
  ThreeColSevenStories: wrapEager(wrapCollectionLayout(ThreeColSevenStories)),
  FourColumnTenStories: wrapEager(wrapCollectionLayout(FourColumnTenStories)),
  ThreeColSevenStoriesVarOne: wrapEager(wrapCollectionLayout(ThreeColSevenStoriesVarOne)),
  ThreeColumnNineStoriesVarOne: wrapEager(wrapCollectionLayout(ThreeColumnNineStoriesVarOne)),
  OneColOneStory: wrapEager(wrapCollectionLayout(OneColOneStory)),
  ThreeColEighteenStories: wrapEager(wrapCollectionLayout(ThreeColEighteenStories)),
  ThreeColumnNineStoriesVarTwo: wrapEager(wrapCollectionLayout(ThreeColumnNineStoriesVarTwo)),
  ThreeColNineStoriesVarOneWithBG: wrapEager(wrapCollectionLayout(ThreeColNineStoriesVarOneWithBG)),
  TwoColumnOneStoryVarOne: wrapEager(wrapCollectionLayout(TwoColumnOneStoryVarOne)),
  ThreeColumnFiveStories: wrapEager(wrapCollectionLayout(ThreeColumnFiveStories)),
  BreakingNewsProminent: wrapEager(wrapCollectionLayout(BreakingNewsProminent)),
  YoutubeComponent: wrapEager(wrapCollectionLayout(YoutubeComponent)),
  FourColumnFourStoriesVarTwo: wrapEager(wrapCollectionLayout(FourColumnFourStoriesVarTwo)),
  ThreeColTwelveOrEighteenStories: wrapEager(wrapCollectionLayout(ThreeColTwelveOrEighteenStories)),
  Games: wrapEager(wrapCollectionLayout(Games)),
  TopComponentSectionPage: wrapEager(wrapCollectionLayout(TopComponentSectionPage)),
  ThreeColNineteenStoriesVarTwo: wrapEager(wrapCollectionLayout(ThreeColNineteenStoriesVarTwo)),
  TopComponentHomePage: wrapEager(wrapCollectionLayout(TopComponentHomePage)),
  ThreeColumnNineStoriesVarThree: wrapEager(wrapCollectionLayout(ThreeColumnNineStoriesVarThree)),
  SixColumnSevenStories: wrapEager(wrapCollectionLayout(SixColumnSevenStories)),
  defaultTemplate: wrapEager(wrapCollectionLayout(SixColumnSixStories)),
};
